import {
  Button,
  useDisclosure,
  type ButtonProps,
} from '@frontend/legacy-components';

import { SupportDrawer } from './SupportDrawer';

export type ContactSupportButtonProps = ButtonProps;

export const ContactSupportButton = ({
  variant = 'link',
  size = 'md',
  children = 'contact support',
  ...restProps
}: ContactSupportButtonProps) => {
  const supportDrawerDisclosure = useDisclosure();

  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={supportDrawerDisclosure.onOpen}
        {...restProps}
      >
        {children}
      </Button>
      <SupportDrawer {...supportDrawerDisclosure} />
    </>
  );
};
